import { getMenu } from '../services/subMenuService';

export const SET_MENU_DETAIL = 'SET_MENU_DETAIL';

export const getMenuAction = () => async dispatch => {
  try {
    const response = await getMenu();
    dispatch({ type: SET_MENU_DETAIL, payload: response.data });
  } catch (error) {
    console.error(error);
  }
};
